import React from 'react';

import { Flex, FlexItem, FlexBlock, Button } from '@wordpress/components';
import StepTitle from './elements/StepTitle';
import PaymentDetails from './elements/PaymentDetails';
import InvoicesList from './elements/InvoicesList';

const Account = (props) => {
  // console.log("Account cstr:", props.prices);
  return (
    <Flex className='step-holder'>
      {/* TITLE & PLAN DETAILS */}
      <StepTitle>My Account</StepTitle>
      <StepTitle className='step-description'>
        {(!props.plan ? 'Free' : 'Premium') + ' Plan'}
      </StepTitle>
      {props.plan && (
        <StepTitle className='step-description'>
          {(props.plan === 'month' ? 'Monthly' : 'Yearly') +
            ' Subscription - ' +
            '$' +
            props.prices[props.plan] / 100 +
            ' / ' +
            props.plan}
        </StepTitle>
      )}

      <FlexBlock />

      {/* PAYMENT DETAILS */}
      <PaymentDetails
        card={props.card}
        changeFunction={() => props.nextFunction('card')}
      />

      {/* INVOICES LIST */}
      <InvoicesList invoices={props.invoices} />

      <FlexBlock />

      {/* UPGRADE / DOWNGRADE button */}
      <Flex className='step-footer'>
        <FlexBlock />
        <Button
          isPrimary={!props.plan}
          isDestructive={props.plan}
          onClick={() => {
            // console.log('card before upgrade:', props.card);
            if (props.card && props.card.last4) props.nextFunction('plans');
            else props.nextFunction('card');
          }}
        >
          {!props.plan ? 'Upgrade' : 'Cancel Subscription'}
        </Button>
      </Flex>
    </Flex>
  );
};

export default Account;
